<template>
  <div class="container">
      <div>
        <!--试卷头部-->
        <div class="title">
          <div>
            <div class="name">
              {{ testPaperTitleInfoVO.testPaperName }}
            </div>
          </div>
          <div class="text">
            <div>
              共{{ testPaperTitleInfoVO.testTotalNum }}道题 共{{
                testPaperTitleInfoVO.testTotalScore
              }}分
            </div>
          </div>
        </div>
        <!--试卷题目明细-->
        <div
          v-for="(testPaperReadItem,
          testPagerReadIndex) in testPaperQuetionList"
          :key="testPagerReadIndex"
          style="width: 100%; margin: 10px"
        >
          <div class="question_1">
            <div class="question_2">
              <div class="questionTypeBorder">
                <span class="questionType">
                  {{ testPaperReadItem.questionType == "01" ? "单选题" : "" }}
                  {{ testPaperReadItem.questionType == "02" ? "多选题" : "" }}
                  {{ testPaperReadItem.questionType == "03" ? "判断题" : "" }}
                </span>
              </div>
              <span class="questionTitle">
                {{ testPagerReadIndex + 1 }}.{{
                  testPaperReadItem.questionContent
                }}
              </span>
              <span class="questionScore">
                ({{ testPaperReadItem.questionScore }}分)
              </span>
            </div>
          </div>
          <div style="margin-top: 5px">
            <!--单选按钮-->
            <div v-if="testPaperReadItem.questionType !== '02'">
              <div
                class="box"
                v-for="(item, index) in testPaperReadItem.optionList"
                :key="index"
              >
                <label></label>
                <div
                  class="box"
                  @click="radioClick(item, index, testPaperReadItem)"
                >
                  <input
                    class="radio-hidden"
                    type="radio"
                    :name="item.name"
                    :id="item.id"
                    value="1"
                    v-model="item.answerFlg"
                  />
                  <div class="radio noselect">
                    <div class="noselect">{{ getCharCode(index) }}</div>
                    <div class="radio-checked noselect">
                      <div style="margin-top: 5px" class="noselect">
                        {{ getCharCode(index) }}
                      </div>
                    </div>
                  </div>
                  <label
                    :for="item.id"
                    style="width: auto; margin: 4px 10px 0 -2px"
                  >
                    <span
                      class="questionContent_class"
                      v-if="
                        testPaperReadItem.questionType == '03' && index == 0
                      "
                      >对</span
                    >
                    <span
                      class="questionContent_class"
                      v-if="
                        testPaperReadItem.questionType == '03' && index == 1
                      "
                      >错</span
                    >
                  </label>
                </div>
                <div
                  class="questionContent_class"
                  style="margin-left: -8px; margin-top: 16px"
                  v-if="testPaperReadItem.questionType === '01'"
                >
                  {{ item.content }}
                </div>
              </div>
            </div>
            <!--单选按钮-->

            <!--多选按钮-->
            <div
              v-if="testPaperReadItem.questionType === '02'"
              style="width: 1100px"
            >
              <div
                class="box"
                v-for="(item, index) in testPaperReadItem.optionList"
                :key="index"
              >
                <label></label>
                <div class="radio-box">
                  <BBtnCheckboxCircle
                    :id="String(item.id)"
                    v-model="item.checkedFlag"
                    style="text-align: right"
                    :label-text="getCharCode(index)"
                    @click="
                      checkBoxClick(item.checkedFlag, index, testPaperReadItem)
                    "
                  />
                </div>
                <div class="questionContent_class" style="margin-top: 5px">
                  {{ item.content }}
                </div>
              </div>
            </div>
            <!--答案-->
            <div class="answerDiv">
              <div class="answerDiv_left">
                <div class="label1">学员答案：</div>
                <div class="label1_sub">
                  <div
                    v-if="testPaperReadItem.questionType !== '02'"
                    style="font-size: 16px;text-valign: left；text-align: end; "
                    v-bind:class="'answerTrue'"
                  >
                    {{
                      getCharCode(
                        testPaperReadItem.studentAnswerVO.studentAnswerIndex - 1
                      )
                    }}
                  </div>
                  <div
                    v-if="testPaperReadItem.questionType === '02'"
                    style="font-size: 16px;text-valign: left；text-align: end; "
                     v-bind:class="'answerTrue'"
                  >
                    {{
                      getSelectMoreCodes(
                        testPaperReadItem.studentAnswerVO.studentAnswerIndexList
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--按钮操作-->
        <div class="box box-btn">
            <BBtnPrimary
              :clicked="doSave"
              btn-txt="提交"
              :disabled="String(disabledFlag)"
            />
            <BBtnPrimary :clicked="doBack" btn-txt="返回"/>
        </div>
      </div>
  </div>
</template>
<script>
import { theoryDetail,theorySave } from "@/api/stuTestPaper";
import BBtnCheckboxCircle from "../../components2/BBtnCheckboxCircle";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
export default {
  name: "testPaperReviewTheoryAdd",
  components: {
    BBtnCheckboxCircle,
    BBtnPrimary,
  },
  data: () => ({
    snackbar: false,
    timeout: 3000,
    snackbarColor: "success",
    snackbarText: "",
    studentTestPaperId: null,
    releaseId: null,
    classId: null,
    startTime: null,
    testPaperQuetionList: [],
    testPaperTitleInfoVO: {},
    disabledFlag: true,
    checkFlag: "",
    reviewStatus: "03",
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        studentTestPaperId: vm.$route.params.studentTestPaperId,
        releaseId: vm.$route.params.releaseId,
        classId: vm.$route.params.classId,
      };
      // 参数赋值
      if ( params.releaseId !== undefined &&
        params.releaseId !== null &&
        params.releaseId !== "" ) {
          // 把不为空的参数存入缓存
          vm.$store.commit("SET_STU_TEST_PAPER_THEORY_PARAMS", params);
      }
      // 参数赋值 发布试卷的id
      if (
        vm.$store.state.stuTestPagerTheory_releaseId !== undefined &&
        vm.$store.state.stuTestPagerTheory_releaseId !== null &&
        vm.$store.state.stuTestPagerTheory_releaseId !== ""
      ) {
        vm.releaseId =
          vm.$store.state.stuTestPagerTheory_releaseId;
        vm.studentTestPaperId =
          vm.$store.state.stuTestPagerTheory_studentTestPaperId;  
        vm.classId =
          vm.$store.state.stuTestPagerTheory_classId;  
      }
      vm.getTestPagerDetail();
    });
  },
  methods: {
    checkBoxClick(checkedFlag, index, insertParam) {
      for (var i = 0; i < insertParam.optionList.length; i++) {
        console.log("i = ",i)
        console.log("index = ",index)
        if (i === index) {
          if (checkedFlag === true) {
            insertParam.optionList[i].answerFlg = "1";
          } else {
            insertParam.optionList[i].answerFlg = "0";
          }
        } 
      }
      var changeSelectArry = [];
      // 获取已经选中的复选框
      for (var j = 0; j < insertParam.optionList.length; j++) {
        if (insertParam.optionList[j].answerFlg === "1" && insertParam.optionList[j].checkedFlag === true) {
          changeSelectArry.push(j + 1);
          console.log("changeSelectArry = ",insertParam)
        }
      }
      insertParam.studentAnswerVO.studentAnswerIndexList = changeSelectArry;

    },
    getSelectMoreCodes(selectIndexList) {
      var codeStrs = "";
      for (var i = 0; i < selectIndexList.length; i++) {
        codeStrs += this.getCharCode(selectIndexList[i] - 1);
      }
      return codeStrs;
    },
    radioClick(item, index, testPaperReadItem) {
      document.getElementById(item.id).checked = true;
      item.checkedFlag = true;

      var newIndex = -1;
      for (var i = 0; i < testPaperReadItem.optionList.length; i++) {
        if (i === index) {
          newIndex = index + 1;
          testPaperReadItem.optionList[i].answerFlg = "1";
        } else {
          testPaperReadItem.optionList[i].answerFlg = "";
        }
      }
      //答案正确
      testPaperReadItem.studentAnswerVO.studentAnswerIndex = newIndex;
      if (newIndex === testPaperReadItem.testPaperAnswerIndex) {
        testPaperReadItem.studentAnswerVO.answerFlag = true;
        // 每题得分
        testPaperReadItem.studentAnswerVO.score = parseInt(
          testPaperReadItem.questionScore
        );
      } else {
        testPaperReadItem.studentAnswerVO.answerFlag = false;
        testPaperReadItem.studentAnswerVO.score = 0;
      }
    },

    // 点击详情
    getTestPagerDetail() {
      this.fetchData();
    },
    async fetchData() {
      
      const params = {
        classId: this.classId,
        releaseId: this.releaseId,
        studentTestPaperId: this.studentTestPaperId,
      };
      const data = await theoryDetail(params);
      // 考题列表
      this.testPaperQuetionList = data.data.questionVOList;
      // 学员得分信息
      this.testPaperTitleInfoVO = data.data.testPaperTitleInfoVO;
      // 是否已批阅
      this.reviewStatus = data.data.readFlag;
      // 开始时间
      this.startTime = data.data.startTime
      if (data.data.readFlag === "03") {
        this.disabledFlag = true;
      } else {
        this.disabledFlag = false;
      }
    },
    // A~Z的取得
    getCharCode(index) {
      if (index==-1) {
        return "";
      }
      const str = "A";
      const strR = String.fromCharCode(str.charCodeAt() + index);
      return strR
    },
    // 提交
    async doSave() {
      var selectOptionList = [];
      // 获取已经选中的复选框
      var selectCheckFlg = false;
      for (var i = 0; i < this.testPaperQuetionList.length; i++) {
        var inputParam = {};
        inputParam.questionId = this.testPaperQuetionList[i].questionId;
        var changeSelectStr = "";
        for (var j = 0; j < this.testPaperQuetionList[i].optionList.length; j++) {
          if (this.testPaperQuetionList[i].optionList[j].answerFlg === "1"
                 && this.testPaperQuetionList[i].optionList[j].checkedFlag === true) {
            changeSelectStr +=
              this.testPaperQuetionList[i].optionList[j].id + ",";
              selectCheckFlg = true;
          }
        }
        if (changeSelectStr.length > 0) {
          changeSelectStr = changeSelectStr.substring(
            0,
            changeSelectStr.length - 1
          );
        }
        inputParam.answerFlg = changeSelectStr;
        inputParam.studentScore = this.testPaperQuetionList[i].studentAnswerVO.score;
        selectOptionList.push(inputParam);
      }
      // 验证
      if(!selectCheckFlg){
        Vue.prototype.$valertbar.show("没有选择任何题目，不能提交！");
        return 
      }

      var addParam = {};
      // 班级id
      addParam.classId = this.classId;
      // 发布id
      addParam.releaseId = this.releaseId;
      // 开始时间
      addParam.startTime = this.startTime;
      // 学员答案列表
      addParam.itemVOList = selectOptionList;
      console.log("********addParam********:",addParam);
      const data = await theorySave(addParam);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        // 提交之后 两个按钮都禁用
        this.disabledFlag = true;
        //已经批阅完毕
        this.reviewStatus = "03";

        this.doBack()
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    doBack () {
      this.$router.push({
          name: "stu-homework-management",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.answerDiv {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin: 10px 10px 0 10px;
  width: 95%;
  height: 52px;
  background: #f5f5f5;
}

.answerDiv_left {
  display: flex;
  width: 700px;
  height: 50px;
}
.label1 {
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 50px;
  margin-top: 15px;
  padding-left: 5px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.label1_sub {
  display: block;
  width: 50px;
  height: 50px;
  margin-top: 15px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.question_1 {
  width: 100%;
}
.question_2 {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px;
}

.top {
  padding-top: 0px;
}
.bottom {
  padding-bottom: 0px;
}

.container {
  display: flex;
  flex-direction: row;
  width: 100%;
  // padding-top: 50px;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.name {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
}
.text {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.inner-box {
  display: flex;
  flex-direction: row;
}

.scoreContent {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 100px;
}
.score-text {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.score-value {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.inner-line {
  display: flex;
  flex-direction: row;
}
.box-right {
  margin-left: 20px;
  margin-top: 20px;
}

label {
  /* margin: 0 10px; */
  margin: 0px 10px 0 20px;
  width: 60px;
  font-size: 14px;
  color: #333333;
  text-align: right;
}

.box {
  display: flex;
  margin-top: 10px;
}

.radio-box {
  display: flex;
  align-items: center;
}

.radio-hidden {
  display: none;
}

.radio-hidden:checked + div div {
  display: block;
}

.radio {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  cursor: pointer;
  border: 1px solid #c8c8c8;
  background: white;
  color: #666666;
  font-size: 16px;
  margin-right: 10px;
}

.radio-checked {
  position: absolute;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 36px;
  height: 36px;
  color: white;
  border-radius: 50%;
  background: #07ae55;
  border: none;
  display: none;
}

.radio:hover,
.radio:active {
  background: rgba(234, 234, 234, 0.99);
}

.button:active {
  background: rgba(206, 206, 206, 0.99);
}

.radio-checked:hover {
  background: #09d267;
}

.radio-checked:active {
  background: #078241;
}

.questionTypeBorder {
  min-width: 6%;
  height: 26px;
  border: 1px solid #edb903;
  margin-right: 5px;
  text-align: center;
}

.questionType {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #edb903;
}

.questionTitle {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.questionScore {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #b3bbbe;
  min-width: 6%;
}
.homework_class {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-left: 23px;
}

.answerTrue {
  color: #07ae55;
}

.answerFalse {
  color: #f32525;
}

.questionContent_class {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.box-btn {
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-left: 20px;
}
</style>
